var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-face"},[(_vm.userInfo.is_face===0)?_c('AddFace',{on:{"close":_vm.success}}):_c('div',{staticClass:"profile-mod-status"},[_vm._v("已录入")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }